import React from 'react'
import Head from 'next/head'
import { number } from 'prop-types'
import createQuery from '../src/query/error/error'
import retrieveData from '../src/lib/retrieve-data'

import Container from '@/component/Primitive/Container'
import Stack from '@/component/Primitive/Stack'
import Type from '@/component/Primitive/Type'
import TextAlign from '@/component/Primitive/TextAlign'
import ButtonStandard from '@/component/Primitive/ButtonStandard'
import Spacer from '@/component/Primitive/Spacer'

const ErrorPage = ({ statusCode }) => (
  <>
    <Head>
      <meta name="googlebot" content="noindex" />
      <meta name="robots" content="noindex" />
    </Head>
    <Spacer my={17}>
      <Container center gutter size="small">
        <TextAlign center>
          <Stack>
            <Type size="heading0" weight="bold">
              Error: {statusCode}
            </Type>
            <div>
              <Type color="#646464">
                Sorry, this page is not found. Click below to take you back to
                home.
              </Type>
            </div>
            <ButtonStandard
              to="/section"
              as="/"
              iconFirst
              icon="arrow-left"
              size="large"
              primary
            >
              Home
            </ButtonStandard>
          </Stack>
        </TextAlign>
      </Container>
    </Spacer>
  </>
)

ErrorPage.getInitialProps = async (context) => {
  const { req, res, err } = context
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404

  const query = createQuery()
  const { data } = await retrieveData(context, query)
  const instance =
    (data && data.instance) || (req && req.instance) || context.instance
  return { ...data, statusCode, instance }
}

ErrorPage.propTypes = {
  statusCode: number
}

export default ErrorPage
